import { useState } from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/site";

const UNITS_FILTER = ["Todas", "Infraestrutura", "Nexus Internet", "Vision", "Monal"];

export const Depoimentos = () => {
  const [filter, setFilter] = useState("Todas");
  const filtered =
    filter === "Todas" ? TESTIMONIALS : TESTIMONIALS.filter((t) => t.unit === filter);

  return (
    <section
      id="depoimentos"
      data-testid="depoimentos-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div className="max-w-2xl">
            <span className="overline">Depoimentos</span>
            <h2 className="font-display mt-4 text-3xl md:text-5xl font-medium tracking-tight text-white leading-[1.08]">
              Quem já confia no{" "}
              <span className="text-white/60 italic font-light">Grupo Nexus</span>.
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {UNITS_FILTER.map((u) => {
              const active = u === filter;
              return (
                <button
                  key={u}
                  onClick={() => setFilter(u)}
                  data-testid={`testimonial-filter-${u}`}
                  className={`text-[12px] rounded-full border px-4 py-2 transition-colors ${
                    active
                      ? "border-white text-white bg-white/5"
                      : "border-white/10 text-white/60 hover:text-white hover:bg-white/[0.03]"
                  }`}
                >
                  {u}
                </button>
              );
            })}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="relative rounded-2xl border border-white/10 bg-[#0A0810] p-7 md:p-8 transition-all duration-300 hover:border-white/25 hover:-translate-y-0.5"
            >
              <Quote size={22} className="text-white/25" />
              <blockquote className="mt-5 text-[15.5px] md:text-[16px] text-white/90 leading-relaxed font-light">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-7 pt-5 border-t border-white/10 flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-white">{t.author}</div>
                  <div className="text-[12px] text-white/50 mt-0.5">{t.role}</div>
                </div>
                <span className="text-[10px] uppercase tracking-[0.2em] text-white/45 border border-white/10 rounded-full px-2.5 py-1">
                  {t.unit}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Depoimentos;
